import axios from "axios";

const KEY = "bkm_admin_token";
export const adminToken = {
  get: () => localStorage.getItem(KEY),
  set: (t) => localStorage.setItem(KEY, t),
  clear: () => localStorage.removeItem(KEY),
};

export const adminApi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/admin`, timeout: 30000 });

adminApi.interceptors.request.use((c) => {
  const t = adminToken.get();
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

adminApi.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e.response?.status === 401 && !e.config.url.startsWith("/auth/")) {
      adminToken.clear();
      window.location.assign("/admin/login");
    }
    return Promise.reject(e);
  },
);

export const aErr = (e) => e?.response?.data?.detail || (e?.response ? "erreur" : "réseau indisponible");

export const downloadCsv = async (name) => {
  const r = await adminApi.get(`/export/${name}.csv`, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${name}.csv`;
  a.click();
  URL.revokeObjectURL(url);
};

export const fmt = (n) => `${new Intl.NumberFormat("fr-FR").format(n || 0)} XAF`;
export const fdate = (d) => (d ? new Date(d).toLocaleString("fr-FR") : "—");
